import Vue from 'vue'
import Router from 'vue-router'
import {Toast} from 'cube-ui'
import {isLogin} from '@/common/api/member'
import {getSign} from '@/common/api/login'

Vue.use(Router)

let handleLogin = (next) => {
	isLogin().then((res) => {
		next()
		// 写入登录来源
		sessionStorage.setItem('login_from', res.data.login_from)
	}).catch((err) => {
		if (err.status == 30001) {
			next()
			// window.location.href = 'https://open.cangqiongkanshu.com/novel/Novelweixin/weiXinLogin'
		} else {
			next()
		}
	})
}

const router = new Router({
	mode: 'hash',
	routes: [{
		path: '/register',
		name: 'register',
		component: () => import('@/views/Login/register')
	},{
		path: '/login',
		name: 'login',
		component: () => import('@/views/Login/login')
	}, {
		path: '/mobileLogin',
		name: 'mobileLogin',
		component: () => import('@/views/Login/mobileLogin')
	}, {
		path: '/setPassWord',
		name: 'setPassWord',
		component: () => import('@/views/Login/setPassWord')
	}, {
		path: '/findPassWord',
		name: 'findPassWord',
		alias: '/weixinFindPwdBind',
		component: () => import('@/views/Login/findPassWord')
	}, {
		path: '/resetPassWord',
		name: 'resetPassWord',
		component: () => import('@/views/Login/resetPassWord')
	}, {
		path: '/resetMobile',
		name: 'resetMobile',
		component: () => import('@/views/Login/resetMobile')
	}, {
		path: '/bindMobile',
		name: 'bindMobile',
		component: () => import('@/views/Login/bindMobile')
	}, {
		path: '/wechatBindMobile',
		name: 'wechatBindMobile',
		component: () => import('@/views/Login/wechatBindMobile')
	}, {
		path: '/',
		name: 'bookcity',
		alias: '/bookcity',
		component: () => import('@/views/Book/city')
	}, {
		path: '/bookshelf',
		name: 'bookshelf',
		redirect: '/bookrank',
		component: () => import('@/views/Book/shelf'),
		children: [{
			path: '/bookrank',
			name: 'bookrank',
			component: () => import('@/components/BookList/bookrank')
		}, {
		path: '/video',
		name: 'video',
		component: () => import('@/views/Book/video')
	}, {
		path: '/video',
		name: 'video',
		component: () => import('@/views/video/video1')
	}, {
			path: '/bookhistory',
			name: 'bookhistory',
			component: () => import('@/components/BookList/bookhistory'),
			beforeEnter: (to, from, next) => {
				handleLogin(next)
			}
		}]
	}, {
		path: '/bookbatch',
		name: 'bookbatch',
		component: () => import('@/views/Book/batch')
	},
	{
		path: '/music',
		name: 'music',
		component: () => import('@/views/Book/music')
	},
	{
		path: '/bookmenu',
		name: 'bookmenu',
		component: () => import('@/views/Book/menu')
	}, {
		path: '/search',
		name: 'search',
		component: () => import('@/views/Search')
	}, {
		path: '/category/:type',
		name: 'category',
		component: () => import('@/views/Category'),
	}, {
		path: '/categoryList/:parentCateId/:title',
		name: 'categoryList',
		component: () => import('@/views/Category/list'),
		props: true
	}, {
		path: '/details',
		name: 'details',
		component: () => import('@/views/Details')
	}, {
		path: '/commentAll',
		name: 'commentAll',
		component: () => import('@/views/Comment')
	}, {
		path: '/setComment',
		name: 'setComment',
		component: () => import('@/views/Comment/set')
	}, {
		path: '/myComment',
		name: 'myComment',
		component: () => import('@/views/My/Comment')
	}, {
		path: '/readHistory',
		name: 'readHistory',
		component: () => import('@/views/My/ReadHistory')
	}, {
		path: '/message',
		name: 'message',
		component: () => import('@/views/My/Message')
	}, {
		path: '/messageDetails',
		name: 'messageDetails',
		component: () => import('@/views/My/MessageDetails')
	}, {
		path: '/noticeDetails',
		name: 'noticeDetails',
		component: () => import('@/views/My/noticeDetails')
	}, {
		path: '/userProtocol',
		name: 'userProtocol',
		component: () => import('@/views/My/userProtocol')
	}, {
		path: '/privacyPolicy',
		name: 'privacyPolicy',
		component: () => import('@/views/My/privacyPolicy')
	}, {
		path: '/about',
		name: 'about',
		component: () => import('@/views/My/about')
	}, {
		path: '/setting',
		name: 'setting',
		component: () => import('@/views/My/setting')
	}, {
		path: '/account',
		name: 'account',
		component: () => import('@/views/My/account')
	}, {
		path: '/userInfo',
		name: 'userInfo',
		component: () => import('@/views/My/userInfo')
	}, {
		path: '/userName',
		name: 'userName',
		component: () => import('@/views/My/userName')
	}, {
		path: '/home',
		name: 'home',
		component: () => import('@/views/My/home'),
		beforeEnter: (to, from, next) => {
			handleLogin(next)
		}
	}, {
		path: '/vip',
		name: 'vip',
		component: () => import('@/views/My/vip')
	}, {
		path: '/conversion',
		name: 'conversion',
		component: () => import('@/views/My/conversion')
	}, {
		path: '/ebook',
		name: 'ebook',
		component: () => import('@/views/Ebook')
	}, {
		path: '/paySuccees',
		name: 'paySuccees',
		component: () => import('@/views/My/paySuccees')
	}, {
		path: '/apply',
		name: 'apply',
		component: () => import('@/components/Apply/apply')
	}, {
		path: '/downloadApp',
		name: 'downloadApp',
		component: () => import('@/views/DownloadApp/downloadApp')
	}, {
		path: '/svip',
		name: 'svip',
		component: () => import('@/views/svip/svip')
	}, {
		path: '/signin',
		name: 'signin',
		component: () => import('@/views/My/signin'),
		beforeEnter: (to, from, next) => {
			handleLogin(next)
		}
	}, {
		path: '/ContractedWriter',
		name: 'ContractedWriter',
		component: () => import('@/views/My/ContractedWriter.vue')
	}, {
		path: '/Bonus',
		name: 'Bonus',
		component: () => import('@/views/My/Bonus.vue')
	}, {
		path: '/income',
		name: 'income',
		component: () => import('@/views/My/income.vue')
	}, {
		path: '/system/index',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/index')
	}, {
		path: '/system/upload',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/upload')
	}, {
		path: '/system/signin',
		name: '/system/signin',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/signin')
	}, {
		path: '/system/readlist',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/readlist')
	}, {
		path: '/system/category/:parentCateId/:title',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/category')
	}, {
		path: '/system/article/:parentCateId/:title',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/article')
	}, {
		path: '/system/articleDetail/:articleId',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/articleDetail')
	}, {
		path: '/system/menu',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/menu')
	},{
		path: '/system/interactive',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/interactive')
	},{
		path: '/system/comment',
		name: '/system/comment',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/comment')
	},{
		path: '/system/setmessage',
		name: '/system/setmessage',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/setmessage')
	},{
		path: '/system/detail',
		name: '/system/detail',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/detail')
	}, {
		path: '/system/book',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/book')
	}, {
		path: '/system/mobilelogin',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/mobilelogin')
	}, {
		path: '/system/login',
		meta: {
      title: '战疫阅享系统'
    },
		component: () => import('@/views/system/login')
	}]
})

router.beforeEach((to, from, next) => {
	const verifyLogin = ['bindMobile', 'myComment', 'message', 'setting', 'username', 'userInfo', 'account', 'conversion',
	'setComment', 'vip', 'resetPassWord', 'resetMobile', 'readHistory', 'income', 'signin', 'Bonus', 'vip', '/system/signin', '/system/setmessage', '/system/comment']

	// 根据不同系统切换标题
	document.title = to.meta.title || "苍穹悦读"

	if (verifyLogin.includes(to.name)) {
		isLogin().then((res) => {
			next()
			// 写入登录来源
			sessionStorage.setItem('login_from', res.data.login_from)
		}).catch((err) => {
			// 上传笔记签先登陆
			if (to.name === '/system/signin' || to.name === '/system/setmessage' || to.name === '/system/comment') {
				next('/system/mobilelogin')
			} else {
				next('/login')
			}
		})
	} else {
		next()
	}
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js